import { Component, AfterViewInit, EventEmitter, OnInit, Output, ElementRef, ViewChild, Inject } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { Observable, Subscriber } from 'rxjs';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { element } from 'protractor';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { PaymentHistoryComponent } from '../payment-history/payment-history.component';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-exam-fee-process',
  templateUrl: './exam-fee-process.component.html',
  styleUrls: ['./exam-fee-process.component.scss']
})
export class ExamFeeProcessComponent implements OnInit {
  FeeForm :FormGroup;
  sTypeList: any;
  filteredsTypeList: any;
  stuStatusList: any;
  filteredstuStatusList: any;
  AdModeList: any;
  filteredAdModeList: any;
  SRList: any;
  filteredSR: any;
  totalAmount = 0;
  lvl: 0;
  zeroError = false;
  inputTimeout: any;
  arrTest: any = [];
  tabldata: any;
  selectedoption: any;
  dialogRef: MatDialogRef<any>;
  submitpayload: any;
  totalPayableAmount: number;
  totalPayAmount = 0;
  remainAmt = 0;
  StudentPersonalId;
  feeMode;
  tabldata2: any;
  ramt: number;
  Total = true;
  Message = false;
  due: number;
  RAmt
  submitButton = true;
  hidebtn = true;
  updateButton = false;
  feeApplyArray: FormArray;
  updateBtn = true;
  payHistoryBtn = false;
  disablePaid = true
  xyz: any;
  errMsg: any;
  payModeList: any;
  shouldShowErrorMessage: boolean = false;
  lastPaid: any;
  newPaid: any;
  filteredpayModeList: any;
  SnNo: any;
  filteredElements: any;
  FeeLevel: any;
  feeModeShow=true;
  ExamCurrency
  userPermission: any;
  utp: any;
  feeCreate=true;
  ShowMsg = false;
  Message2 = ''
  APIService: string;
  RgNo: any;
  constructor(private fb: FormBuilder,
    public umsService: UmsService,public dialogRef1: MatDialogRef<ExamFeeProcessComponent>,
    private httpClient: HttpClient,
    public dialog: MatDialog, private modalPopupService: ModalpopService,
    private spinner: NgxSpinnerService,
    @Inject(MAT_DIALOG_DATA) public data: any,
   ) { this.APIService = environment.serviceUrl }
    FeeTable: any;
    tempCo = sessionStorage.getItem('TemplateCode');
    ngOnInit(): void {
      this.getFeeTempData()
      this.updateBtn = true;
      this.ShowMsg = false;
      this.Message2 = ''
      this.tempCo = sessionStorage.getItem('TemplateCode');
      this.StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
      this.feeMode = this.data.Mode;
      this.totalAmount = 0;
      this.totalPayAmount = 0;
      this.remainAmt = 0;
      this.Total = true;
      this.Message = false;
      this.ramt = 0;
      this.due = 0;
      this.lvl= 0;
      //Apply Exam Fee
      this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
      this.utp = sessionStorage.getItem('usertypeee');
      if(this.utp !== 'Super Admin' && this.utp !== 'Admin'){
        // this.isSuperAdmin= false;
        this.userPermission.forEach(element => {
        if(element.PageName == 'Apply Exam Fee' && element.PCreate == false)
        {
            this.feeCreate = false;  
        }
        // if(element.PageName == 'Apply Admission Fee' && element.PUpdate == false)
        // {
        //     this.feeUpdate = false;  
        // }  
        // if(element.PageName == 'Faculty' && element.PDelete == false)
        // {
        //     this.FacultyDelete = false;  
        // }
      });
    }
      this.FeeForm = this.fb.group({
        TemplateName: new FormControl('',[Validators.pattern('^[a-zA-z0-9- &\\s]*$')]),
        StudentType: new FormControl('',[]),
        StudentStatus: new FormControl(''),
        SocialReservation: new FormControl(''),
        TotalPaidAmount: new FormControl(''),
        PayMode: new FormControl(''),
        feeHeadArray: new FormArray([]),
 
      });
      this.fetchStudentType()
      this.fetchStudentStatus()
      this.fetchSocialReservation();
      this.fetchAddmissionMode();
      this.fetchPayMode();
    }
 
    getFeeTempData() {
      this.spinner.show();
      const payload = {};
      payload['SessionId'] = this.data.SessionId;
      payload['CoCode'] =  this.data.CoCode;
      payload['CgCode'] =  this.data.CgCode
      payload['StuId'] = this.data.StuId;
      payload['FeeType'] = 'EF';
      payload['EmId'] = this.data.Exam
      this.umsService.fetchFeeTemp(payload).subscribe(res => {

        this.spinner.hide();
        if (res.status) {
          this.FeeLevel = res.data[0]['FeeLevel']
           this.ExamCurrency = res.data[0].Currency
          if(res.data[0]['FeeLevel'] == 'SW'){
            this.getRgId()
            // this.getSecretData()
          }
          else if(res.data[0]['FeeLevel'] == 'EW'){
            // this.getSecretData()
            this.getRgId();
          }
        } else {
          this.getSecretData()
          this.FeeLevel = null
        }
      });
    }
 
    getRgId() {
      const payload = {};
      payload['StuId'] = this.data.StuId;
      this.umsService.RgId(payload).subscribe((res) => {
        if (res.status) {
          // this.searchExams(res.data[0]['RgId'])
          this.GetEcId(res.data[0]['RgId'])
        }
        else {
        }
      })
    }
 
    searchExams(RgId){
      let payload = {};
      payload['RgId'] = RgId;
      payload['CoCode'] = this.data.CoCode
       this.umsService.fetchLatestEcid(payload).subscribe((res) => {
         if (res.status) {
            if(res.data[0]['ChkRgId'] == '' || res.data[0]['ChkRgId'] == null){
              this.ExmFormSub(res.data[0]['EcId'],RgId)
            }
            else{
              this.ExmFormSub(res.data[0]['EcId'],RgId)
            }
           
         }
       });
     }
 
     GetEcId(RgId){
      let payload = {};
      payload['RgId'] = RgId;
      payload['CoCode'] = this.data.CoCode
       this.umsService.GetEcId(payload).subscribe((res) => {
         if (res.status) {
          this.RgNo = res.data[0]['RgNo']
            if(res.data[0]['ChkRgId'] == '' || res.data[0]['ChkRgId'] == null){
              this.ExmFormSub(res.data[0]['EcId'],RgId)
            }
            else{
              this.ExmFormSub(res.data[0]['EcId'],RgId)
            }
           
         }
       });
     }
 
     ExmFormSub(EcId, RgId) {
      this.filteredElements = []
      this.spinner.show();
      const payload = {};
      payload['EcId'] = EcId;
      payload['RgId'] = RgId;
      this.umsService.ExmFormSub(payload).subscribe((res) => {
        this.spinner.hide();
        if (res.status) {
          this.ShowMsg = false;
          this.Message2 = ''
           this.filteredElements = res.data.filter(element => {
            if (element.EsType == 'S' && (element.App == 'Y' || element.App == ' ')) {
             return element
            }
          });
          this.getSecretData()
          this.searchExamsValid()
         
         
        }
        else {
          this.updateBtn = true;
          this.ShowMsg = true;
          this.Message2 = 'Exam Form Not Submitted'
        }
 
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
      })
    }
 
   
    searchExamsValid() {
      // this.submitButton = true;
      // this.updateBtn=true;
      let payload = {};
      this.Message2 = ''
      payload['RgNo'] = this.RgNo;
      payload['CgCode'] = this.data.CgCode;
      payload['Valid'] = '';
      payload['Chng'] = '';
      payload['App'] = '';
      payload['EfId'] = 0
      this.umsService.fetchInputExamsValid(payload).subscribe((res) => {
        if (res.status) {
          if (res.data[0]['Valid'] == 'X') {
            // let data = {}
            // data['message'] = 'First Submit Exam Form'
            // data['title'] = 'Alert'
            // data['icon'] = 'fas fa-close'
            // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
            // this.updateBtn = false;
            this.hidebtn = false;
            this.ShowMsg = true;
            this.Message2 = 'First Submit Exam Form'
          }
        }
      });
    }
 
    getSecretData(){
      let payload = {};
      this.umsService.getSecretData().subscribe((res) => {
        this.SnNo = res.projectPharam['SnNo']
        this.prepopulation(res.projectPharam['SnNo']);
      })
     
    }
 
    fetchStudentType() {
      const payload = {};
      payload['CdType'] = 'STYPE';
      this.umsService.getCodeType(payload).subscribe((res) => {
        if (res.status) {
          this.sTypeList = res.data;
          this.filteredsTypeList = this.sTypeList.slice();
        } else {
          //this.apimicroservice.openSnackbar(res.message);
        }
      });
    }
 
   fetchStudentStatus() {
      const payload = {};
      payload['CdType'] = 'STUST';
      this.umsService.getCodeType(payload).subscribe((res) => {
        if (res.status) {
          this.stuStatusList = res.data;
          this.filteredstuStatusList = this.stuStatusList.slice();
        } else {
          //this.apimicroservice.openSnackbar(res.message);
        }
      });
    }
 
    fetchSocialReservation() {
      const payload = {};
      payload['CdType'] = 'SR';
      this.umsService.getCodeType(payload).subscribe((res) => {
        if (res.status) {
          this.SRList = res.data;
          this.filteredSR = this.SRList.slice();
        } else {
          //this.apimicroservice.openSnackbar(res.message);
        }
      });
    }
   fetchAddmissionMode() {
      const payload = {};
      payload['CdType'] = 'AMODE';
      this.umsService.getCodeType(payload).subscribe((res) => {
        if (res.status) {
          this.AdModeList = res.data;
          this.filteredAdModeList = this.AdModeList.slice();
        } else {
          //this.apimicroservice.openSnackbar(res.message);
        }
      });
    }
 
    addNewRow() {
      const creds = this.FeeForm.controls.feeHeadArray as FormArray;
      creds.push(
        this.fb.group({
          FeeHead: new FormControl ('',[Validators.required]),
          HeadName: new FormControl ('',),
          FeePaid: new FormControl (0),  
          FeeDue: new FormControl (0),
          FeeDueDummy:new FormControl (0),
          FeeAmt: new FormControl ('',[Validators.required, Validators.pattern('^[0-9]*$')]),
        })
      );
     
    }
 
   
    prepopulation(SnNo) {
      this.Total = true;
      this.Message = false;
      this.spinner.show();
      const payload = {};
      // payload['TemplateCode'] =  this.data;
      payload['FeeTemplateCode'] = this.data.TempCode;
      payload['StuId'] = this.data.StuId;
      payload['FeeHistory'] = 1;
      payload['SnNo'] = this.data.SessionId;
      this.umsService.getSearchFeeDetails(payload).subscribe((res) => {
        let data = res.data[0];
        this.spinner.hide()
        if (res.status) {
          this.updateButton = true;
          this.submitButton =false;
          // if(res.data[0]['TotalPaidAmount'] == 0 || res.data[0]['FeePaid'] == 0){
          //   this.submitButton = true
          //   this.payHistoryBtn = false
          // }
          // this.disablePaid = false;
         this.tabldata2 = res.data;
          this.FeeForm = this.fb.group({
            TotalPaidAmount: new FormControl(''),
            PayMode: new FormControl(data.PayMode),
            feeHeadArray: new FormArray([]),  
          });
          this.tabldata2 = res.data;
          this.lastPaid = data.TotalPaidAmount
          this.tabldata2.forEach((element,i) => {  
            const creds = this.FeeForm.controls.feeHeadArray as FormArray;
            creds.push(
              this.fb.group({
                FeeHead: new FormControl (element.FeeHead,[Validators.required]),
                HeadName: new FormControl (element.Head),
                FeePaid: new FormControl (0),
                FeeDue: new FormControl (element.FeeDue),
                FeeDueDummy: new FormControl (element.FeeDue),
                FeeAmt: new FormControl (element.FeeDue,[Validators.required, Validators.pattern('^[0-9]*$')]),
              })
            );
               this.FeeForm.controls['TotalPaidAmount'].setValue('');
              if(this.FeeLevel == 'SW'){
                let amount =  parseInt(element.FeeDue) * this.filteredElements.length
                this.totalAmount = this.totalAmount + amount;
                this.remainAmt = this.totalAmount - this.lastPaid
                this.totalPayAmount = this.totalAmount - this.remainAmt;
                this.ramt = this.remainAmt;
                if(this.remainAmt == 0){
                  this.payHistoryBtn = true
                }
                else{
                  this.payHistoryBtn = false
                }
                if (this.totalAmount == 0) {
                  this.FeeForm.controls['TotalPaidAmount'].setValue(0);
                  this.updateBtn = false;
                } else {
                  this.FeeForm.controls['TotalPaidAmount'].setValue('');
                }
              }
              else if(this.FeeLevel == 'EW'){
               
                this.totalAmount = this.totalAmount + parseInt(element.FeeAmt);
                this.remainAmt = this.totalAmount - this.lastPaid
                this.totalPayAmount = this.totalAmount - this.remainAmt;
                this.ramt = this.remainAmt;
                if(this.remainAmt == 0){
                  this.payHistoryBtn = true
                }
                else{
                  this.payHistoryBtn = false
                }
                if (this.totalAmount == 0) {
                  this.FeeForm.controls['TotalPaidAmount'].setValue(0);
                  this.updateBtn = false;
                } else {
                  this.FeeForm.controls['TotalPaidAmount'].setValue('');
                }
              }
              if(this.remainAmt == 0){
                this.updateBtn = true;
                this.Total = false;
                this.Message = true;
                this.payHistoryBtn = true
              }else{
                this.updateBtn = false;
                this.Total = true;
                this.Message = false;
                this.payHistoryBtn = false
              }
            });
        } else {
          this.spinner.show();
          const payload = {};
          payload['TemplateCode'] =  this.data.TempCode;
          payload['FeeType'] = ''
          this.updateButton = false;
          this.submitButton =true;
          // this.disablePaid = true;
          this.umsService.getFeeTemplet(payload).subscribe((res) => {
            this.spinner.hide()
            let data = res.data[0];
            if (res.status) {
             this.tabldata = res.data;
              this.FeeForm = this.fb.group({
                TotalPaidAmount: new FormControl(''),
                PayMode: new FormControl(data.PayMode),
                feeHeadArray: new FormArray([]),  
              });
              this.FeeTable = res.data;
              this.FeeTable.forEach((element,i) => {  
               
                const creds = this.FeeForm.controls.feeHeadArray as FormArray;
                creds.push(
                  this.fb.group({
                    FeeHead: new FormControl (element.FeeHead,[Validators.required]),
                    HeadName: new FormControl (element.Head),
                    FeePaid: new FormControl (0),
                    FeeDue: new FormControl (element.FeeDue),
                    FeeDueDummy: new FormControl (element.FeeDue),
                    FeeAmt: new FormControl (element.FeeAmt,[Validators.required, Validators.pattern('^[0-9]*$')]),
                  })
                );
                if(this.FeeLevel == 'SW'){
                  let amount =  parseInt(element.FeeAmount) * this.filteredElements.length
                  this.totalAmount = this.totalAmount + amount;
                  this.remainAmt = this.totalAmount;
                  this.totalPayAmount = this.totalAmount - this.remainAmt;
                  this.ramt = this.remainAmt;
                  if (this.totalAmount == 0) {
                    this.FeeForm.controls['TotalPaidAmount'].setValue(0);
                    this.updateBtn = false;
                  } else {
                    this.FeeForm.controls['TotalPaidAmount'].setValue('');
                  }
                }
                else if(this.FeeLevel == 'EW'){
                 
                  this.totalAmount = this.totalAmount + parseInt(element.FeeAmount);
                  this.remainAmt = this.totalAmount;
                  this.totalPayAmount = this.totalAmount - this.remainAmt;
                  this.ramt = this.remainAmt;
                  if (this.totalAmount == 0) {
                    this.FeeForm.controls['TotalPaidAmount'].setValue(0);
                    this.updateBtn = false;
                  } else {
                    this.FeeForm.controls['TotalPaidAmount'].setValue('');
                  }
                }
                });
             
     
            } else {
              // this.umsService.openSnackbar(res.message);
            }
          });
        }
      });
   
     
    }
    errorcheckP(i){
      return i.controls['FeePaid'].touched && i.controls['FeePaid'].errors?.pattern
     
     
    }
    errorcheckR(i){
      return i.controls['FeePaid'].touched && i.controls['FeePaid'].errors?.required
   
   }
 
   getfeeHeadArrayControls() {
    return (this.FeeForm.get('feeHeadArray') as FormArray).controls;
  }
 
  close(){
  this.dialogRef1.close();
  }
 
  submitFeeTemplet(){
    if(this.FeeForm.invalid){
      this.FeeForm.get('TotalPaidAmount').markAsUntouched();
    }
    else{
      this.submit()
    }
  }
 
  submit() {
    this.data.Status
    if(this.data.Status == 'PayLater'){
      this.delete();
    }
    else{
      this.save()
    }
  }
 
  delete(){
    this.submitpayload = this.FeeForm.value;
    let abcd = this.FeeForm.get('feeHeadArray') as FormArray;
    let payload = abcd.value;
    let iserror = false;
    var bar = new Promise<void>((resolve, reject) => {
      payload.forEach((element, index, array) => {
        const options = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
          }),
          body: {
            FeeTemplateCode: this.data.TempCode,
            StuId: this.data.StuId,
            FeeType: 'EF',
            FeeHead: element.FeeHead,
            FeeStatus: '',
            FeeAmt: element.FeeAmt,
            FeePaid: 0,
            FeeDue: element.FeeDue,
            FeeDueDummy: element.FeeDue,
            FeePaymentMethod: '',
            TotalPaidAmount: 0,
            PayMode: '',
            SnNo: this.data.SessionId,
            CreatedBy: '',
            TotalFeeAmount: 0
          },
        };
        this.httpClient.delete(this.APIService + '/fees/PayFeeDetails', options)
          .subscribe((s) => {
            let cc = [];
            cc.push(s);
            if (cc[0].status == false){
              iserror = true;
              this.errMsg = cc[0].message
            }
            if (index === array.length -1) resolve();
            else {
              iserror = false
              this.errMsg = cc[0].message
             
            }
            if (index === array.length - 1) resolve();
 
            this.spinner.hide();
            // let cc = [];
            // cc.push(s);
            // let data = {}
            // data['message'] = cc[0].message
            // data['title'] = 'Information'
            // data['icon'] = 'fas fa-check'
            // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
            // this.dialogRef.afterClosed().subscribe(result => {
 
            // });
          }, (ERROR: HttpErrorResponse) => {
            if (index === array.length - 1) resolve();
 
            this.spinner.hide();
            // let data = {}
            // data['message'] = ERROR.error.message
            // data['title'] = 'Alert'
            // data['icon'] = 'fas fa-close'
            // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
            // this.ngOnInit();
            // this.umsService.openSnackbar(ERROR.error.message);
 
          });
      });
     
    });
 
    bar.then(() => {
      if(iserror == false){
        this.save();
      }
    });
  }
 
  save(){
    this.updateBtn = true;
    this.spinner.show();
    this.submitpayload = this.FeeForm.value;
    let abcd = this.FeeForm.get('feeHeadArray') as FormArray;
    let payload = abcd.value;
    let iserror = false;
    var bar = new Promise<void>((resolve, reject) => {
      payload.forEach((element, index, array) => {
        let arr1 = [];
        if(this.FeeLevel == 'SW'){
          let amtamt = parseInt(element.FeeAmt)  * this.filteredElements.length
          arr1.push(
            this.fb.group({
             FeeTemplateCode: new FormControl(this.data.TempCode), //add neww
             StuId: new FormControl(this.data.StuId),
             FeeType: new FormControl('EF'),
             FeeHead: new FormControl(element.FeeHead),
              FeeAmt: new FormControl(amtamt),
              FeePaid: new FormControl(element.FeePaid),
              FeeDue: new FormControl(element.FeeAmt),
              FeeDueDummy: new FormControl (element.FeeDue),
              FeePaymentMethod: new FormControl(this.feeMode),
              TotalPaidAmount: new FormControl(this.totalAmount),
              PayMode:new FormControl(this.submitpayload.PayMode),
              SnNo: new FormControl(this.data.SessionId),
              CreatedBy: new FormControl(''),
              TotalFeeAmount: new FormControl(this.totalAmount),
              FeeStatus: new FormControl('Y'),
            })
          )
        }
        else if(this.FeeLevel == "EW"){
          arr1.push(
            this.fb.group({
             FeeTemplateCode: new FormControl(this.data.TempCode), //add neww
             StuId: new FormControl(this.data.StuId),
             FeeType: new FormControl('EF'),
             FeeHead: new FormControl(element.FeeHead),
              FeeAmt: new FormControl(element.FeeAmt),
              FeePaid: new FormControl(element.FeePaid),
              FeeDue: new FormControl(element.FeeAmt),
              FeeDueDummy: new FormControl (element.FeeDue),
              FeePaymentMethod: new FormControl(this.feeMode),
              TotalPaidAmount: new FormControl(this.totalAmount),
              PayMode:new FormControl(this.submitpayload.PayMode),
              SnNo: new FormControl(this.data.SessionId),
              CreatedBy: new FormControl(''),
              TotalFeeAmount: new FormControl(this.totalAmount),
              FeeStatus: new FormControl('Y'),
            })
          )
        }
        this.umsService.addFeeTemplet1(arr1[0].value).subscribe(res => {
          this.spinner.hide();
          if (res.status == false) {
            // this.updateBtn = false;
            iserror = true;
            this.errMsg = res.message
          }
          if (index === array.length - 1) resolve();
          else {
            // this.updateBtn = false;
            iserror = false
            this.errMsg = res.message
          }
          if (res.status == true) {
            // this.updateBtn = false;
            iserror = false
            this.errMsg = res.message
           
          }
        }, (ERROR: HttpErrorResponse) => {
          this.spinner.hide();
          iserror = true;
          this.errMsg = ERROR.error.message
          if (index === array.length - 1) resolve();
        });
 
      });
    })
    bar.then(() => {
      if (iserror == false) {
        this.saveApplicationDetails(this.data.StuId,this.data.SessionId)
        if (this.totalAmount == 0) {
          const randomFiveDigitNumber = Math.floor(10000 + Math.random() * 90000);
            let payload = {};
            payload['payment_source'] = 'Pay-0',
            payload['easepayid'] = randomFiveDigitNumber,
            payload['card_type'] = '-',
            payload['mode'] = '-',
            payload['email'] = '',
            payload['phone'] = '',
            payload['key'] = '',
            payload['txnid'] = '',
            payload['status'] = 'Success',
            payload['amount'] = this.totalAmount,
            payload['StuId'] = this.data.StuId,
            payload['FeeTemplateCode'] = this.data.TempCode,
            payload['FeeType'] = 'EF',
            payload['SnNo'] = this.data.SessionId,
            this.umsService.payZeroFee(payload).subscribe((res) => {
              if (res.status) {
                this.saveApplicationDetails(this.data.StuId, this.data.SessionId)
                this.spinner.hide()
                let data = {}
                 data['message'] =  "Waved Off",
                 data['title'] = 'Information'
                 data['icon'] = 'fas fa-check'
                this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
                this.ngOnInit()
              }
              else {
                this.spinner.hide()
                let data = {}
                data['message'] = res.message,
                data['title'] = 'Alert'
                data['icon'] = 'fas fa-close'
                this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

              }
            });
        }
        else{
          const paymentDetails = {
          "payment_source":'',
          "easepayid": "",
          "card_type": "",
          "mode": "",
          "email": " ",
          "phone": "",
          "key": "",
          "txnid": "",
          "status": "",
          "amount": this.totalAmount,
          "StuId": this.data.StuId,
          "FeeTemplateCode": this.data.TempCode,
          "FeeType": "EF",
          "SnNo": this.data.SessionId,
            }
        this.umsService.offlinePayResponce(paymentDetails).subscribe((response) => {
          if(response.status){
            this.updateBtn = false;
            let data = {}
        data['message'] = "Submitted Successfully"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          this.ngOnInit();
        });
          }
         
        });
      }
       
      } else {
        let data = {}
        data['message'] = this.errMsg
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.ngOnInit();
      }
    });
  }
 
  saveApplicationDetails(StuId,SnNo) {
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().slice(0, 10);
    this.spinner.show()
    let payload = {};
    payload['StuId'] = StuId
    payload['SessionId'] = SnNo
    payload['CgCode'] = sessionStorage.getItem("CgCode");
    payload['CoCode'] = sessionStorage.getItem("CoCode");
    payload['ApplicationName'] = 'Exam Fees'
    payload['ApplicationSubDate'] = formattedDate;
    this.umsService.saveApplicationDetails(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
      } else {
        this.spinner.hide()
      }
    })
  }
 
  amountCheck(index) {
    let amountValue = (<FormArray>this.FeeForm.get("feeHeadArray")).at(index).get('FeeDue').value;
    this.FeeTable.forEach((element, i) => {
      if (element.FeeAmount < amountValue) {
        let data = {}
        data['message'] = "Payable Amount Should be Less than Or Equal to Due Amount"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
 
      }
    })
  }
 
  getAmount(event : any,i){
 
  }
 
  onInputChange(val) {
    const tempData = val.target.value;
    this.updateBtn=true;
    // if (tempData.charAt(0) === '0') {
    //   this.zeroError = true;
    // }
    // else if(tempData.charAt(0) !== '0'){
    //   this.zeroError = false;
    // }
    if (tempData == '') {
      this.shouldShowErrorMessage = false;
      this.updateBtn = true;
      this.remainAmt = this.ramt;
    }
    if (this.remainAmt == 0 && this.submitButton == true && this.lastPaid == undefined) {
      this.shouldShowErrorMessage = false;
      this.updateBtn = false;
      this.remainAmt = this.totalAmount - tempData;
    }
   
    if (this.ramt < tempData || tempData > this.totalAmount) {
      this.shouldShowErrorMessage = true;
      this.updateBtn = true;
      this.remainAmt = this.ramt;
    }
    else if (tempData == 0) {
      this.shouldShowErrorMessage = false;
      // this.updateBtn = true;
      this.newPaid = 0;
    }
    else {
      if (this.lastPaid == undefined && this.submitButton == true) {
        this.shouldShowErrorMessage = false;
        // this.updateBtn = false;
        this.remainAmt = this.totalAmount - tempData;
        if(this.remainAmt == 0){
          this.updateBtn = false
          // this.payHistoryBtn = true;
         }else{
          this.updateBtn = true
          // this.payHistoryBtn = false;
         }
      }
     
      this.shouldShowErrorMessage = false;
      // this.updateBtn = false;
      this.remainAmt = this.ramt - tempData;
      this.newPaid = parseInt(this.lastPaid) + parseInt(tempData);
      // this.newPaid = parseInt(tempData);
      if(this.remainAmt == 0){
        this.updateBtn = false
        // this.payHistoryBtn = true;
       }else{
        this.updateBtn = true
        // this.payHistoryBtn = false;
       }
    }
  }
 
 
  dueAmt(event,i){
    let arrayData = (<FormArray>this.FeeForm.get("feeHeadArray")).at(i);
    let amountValue = (<FormArray>this.FeeForm.get("feeHeadArray")).at(i).get('FeePaid').value;
    amountValue = parseInt(amountValue);
      const tempData= this.FeeForm.controls.feeHeadArray.value;
      this.arrTest = tempData;
      if(tempData[i]['FeePaid'] == '')
      {
        this.due = tempData[i]['FeeDueDummy'];
      }
      else{
        this.due = parseInt(tempData[i]['FeeDueDummy']) - parseInt(tempData[i]['FeePaid']);
      }
      this.feeApplyArray = this.FeeForm.get('feeHeadArray') as FormArray;
        this.feeApplyArray.at(i).get('FeeDue').setValue(this.due);
  }
 
 
  newFun(event,i){
    let FeeDue1 = (<FormArray>this.FeeForm.get("feeHeadArray")).at(i).get('FeeDue').value;
    const tempData= this.FeeForm.controls.feeHeadArray.value;
      this.arrTest = tempData;
      let sumFeeDue = 0;
    tempData.forEach(element =>{
      sumFeeDue += element.FeeDue;
    })
    this.remainAmt = sumFeeDue;
    this.totalPayAmount = this.totalAmount - this.remainAmt;
  }
 
  updateFeeTemplet(){
    if(this.FeeForm.invalid){
      this.FeeForm.get('TotalPaidAmount').markAsUntouched();
    }
    else{
      this.update()
    }
  }
 
  update() {
    this.zeroError = false;
    this.spinner.show();
    this.FeeForm.controls['TotalPaidAmount'].setValue(this.newPaid);
    this.submitpayload = this.FeeForm.value;
    let abcd = this.FeeForm.get('feeHeadArray') as FormArray;
    let payload = abcd.value;
    let iserror = false;
    var bar = new Promise<void>((resolve, reject) => {
      payload.forEach((element, index, array)=> {
        let arr1 = [];
        if(this.FeeLevel == 'SW'){
          let amtamt = parseInt(element.FeeAmt)  * this.filteredElements.length
          arr1.push(
            this.fb.group({
             FeeTemplateCode: new FormControl(this.data.TempCode), //add neww
             StuId: new FormControl(this.data.StuId),
             FeeType: new FormControl('EF'),
             FeeHead: new FormControl(element.FeeHead),
              FeeAmt: new FormControl(amtamt),
              FeePaid: new FormControl(element.FeePaid),
              FeeDue: new FormControl(element.FeeAmt),
              FeeDueDummy: new FormControl (element.FeeDue),
              FeePaymentMethod: new FormControl(this.feeMode),
              TotalPaidAmount: new FormControl(this.totalAmount),
              PayMode:new FormControl(this.submitpayload.PayMode),
              SnNo: new FormControl(this.data.SessionId),
              CreatedBy: new FormControl(''),
              TotalFeeAmount: new FormControl(this.totalAmount)
            })
          )
        }
        else if(this.FeeLevel == "EW"){
          arr1.push(
            this.fb.group({
             FeeTemplateCode: new FormControl(this.data.TempCode), //add neww
             StuId: new FormControl(this.data.StuId),
             FeeType: new FormControl('EF'),
             FeeHead: new FormControl(element.FeeHead),
              FeeAmt: new FormControl(element.FeeAmt),
              FeePaid: new FormControl(element.FeePaid),
              FeeDue: new FormControl(element.FeeAmt),
              FeeDueDummy: new FormControl (element.FeeDue),
              FeePaymentMethod: new FormControl(this.feeMode),
              TotalPaidAmount: new FormControl(this.totalAmount),
              PayMode:new FormControl(this.submitpayload.PayMode),
              SnNo: new FormControl(this.data.SessionId),
              CreatedBy: new FormControl(''),
              TotalFeeAmount: new FormControl(this.totalAmount)
            })
          )
        }
        this.umsService.updateFeeTemplet(arr1[0].value).subscribe(res => {
         
          this.spinner.hide();
          if (res.status == false){
            iserror = true;
            this.errMsg = res.message
          }
          // if (index === array.length -1) resolve();
          else {
            iserror = false
            this.errMsg = res.message
          }
        },
        (ERROR: HttpErrorResponse) => {
          iserror = true;
          this.errMsg = ERROR.error.message
          if (index === array.length -1) resolve();
        }
        );
      });
    })
    bar.then(() => {
      if(iserror == false){
        let  data = {}
        data['message'] = "Update Successfully"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          this.dialogRef1.close();
        });
      }else{
        this.zeroError = true
        let  data = {}
        data['message'] = this.errMsg
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
     
      }
    });
   
  }
 
 
  openHistoryPopup(){
      // localStorage.clear();
      // sessionStorage.setItem('TemplateCode',item.TemplateCode);
      let data = {};
      data['Temp'] = this.data.TempCode;
      data['StuId'] = this.data.StuId;
      data['SnNo'] = this.data.SessionId
      const dialogRef4 = this.dialog.open(PaymentHistoryComponent,
        {
          disableClose:true,
          width: "900px",
            height: "auto",
            data
        });
        dialogRef4.afterClosed().subscribe((result) => {
         
        });
  }
 
  onInputChange2(val) {
    // clearTimeout(this.inputTimeout);
    // this.inputTimeout = setTimeout(() => {
    //   // this.dueAmt(event,i)
     
    //   // this.onUpdateInput();
    // }, 500);
    // const tempData= this.FeeForm.value;
    const tempData = val.target.value;
    if(tempData.TotalPaidAmount == ''){
      this.updateBtn = false;
        this.remainAmt = this.remainAmt;
    }
    if(this.remainAmt == 0 &&  this.submitButton == true){
      this.remainAmt = this.totalAmount - tempData.TotalPaidAmount;
    }
    else if(this.remainAmt == 0 && this.updateButton == true)
    {
      // this.remainAmt =  this.remainAmt - tempData.TotalPaidAmount;
      // this.newPaid = parseInt(this.lastPaid) + parseInt(tempData.TotalPaidAmount);
      this.remainAmt = 0
    }
    else if(this.remainAmt < tempData.TotalPaidAmount){
      this.shouldShowErrorMessage = true;
      this.updateBtn = true;
      this.remainAmt = this.remainAmt;
    }
    else if(tempData.TotalPaidAmount == 0){
      this.shouldShowErrorMessage = false;
       this.updateBtn = true;
       this.remainAmt =  this.RAmt - tempData.TotalPaidAmount;
       this.newPaid = 0;
     }
    else
    {
      this.shouldShowErrorMessage = false;
      this.updateBtn = false;
      this.remainAmt =   this.RAmt - tempData.TotalPaidAmount;
      this.newPaid = parseInt(this.lastPaid) + parseInt(tempData.TotalPaidAmount);
     
    }
    if(tempData.TotalPaidAmount == this.totalAmount){
      const Data= this.FeeForm.controls.feeHeadArray.value;
      this.FeeTable = Data;
      this.FeeTable.forEach((element,i) => {  
        this.feeApplyArray = this.FeeForm.get('feeHeadArray') as FormArray;
        this.feeApplyArray.at(i).get('FeePaid').setValue(element.FeeAmt);
        });
    }
  }
 
 
  // onUpdateInput() {
  //   // this.shouldShowErrorMessage = false; // Reset the flag
  //   const delayMilliseconds = 500; // Change the delay as per your requirement
 
  //   setTimeout(() => {
  //     if (this.isGreaterThanInput() || this.isSmallerThanInput()) {
  //       // this.shouldShowErrorMessage = true;
  //     }
  //   }, delayMilliseconds);
  // }
  isGreaterThanInput(): boolean {
    const tempData= this.FeeForm.value;
    const Data= this.FeeForm.controls.feeHeadArray.value;
    return +tempData.TotalPaidAmount > this.totalAmount;
  }
 
  isSmallerThanInput(): boolean {
    const tempData= this.FeeForm.value;
    const Data= this.FeeForm.controls.feeHeadArray.value;
    return +tempData.TotalPaidAmount < this.totalAmount;
  }
 
 
  getAmount2(){
    // this.remainAmt = 0;
    const tempData= this.FeeForm.value;
    if(tempData.TotalPaidAmount == ''){
      this.updateBtn = false;
        this.remainAmt = this.remainAmt;
    }
    if(this.remainAmt == 0 &&  this.submitButton == true){
      this.remainAmt = this.totalAmount - tempData.TotalPaidAmount;
    }
    else if(this.remainAmt == 0 && this.updateButton == true)
    {
      // this.remainAmt =  this.remainAmt - tempData.TotalPaidAmount;
      // this.newPaid = parseInt(this.lastPaid) + parseInt(tempData.TotalPaidAmount);
      this.remainAmt = 0
    }
    else if(this.remainAmt < tempData.TotalPaidAmount){
      this.shouldShowErrorMessage = true;
      this.updateBtn = true;
      this.remainAmt = this.remainAmt;
    }
    else if(tempData.TotalPaidAmount == 0){
      this.shouldShowErrorMessage = false;
       this.updateBtn = true;
       this.remainAmt =  this.RAmt - tempData.TotalPaidAmount;
       this.newPaid = 0;
     }
    else
    {
      this.shouldShowErrorMessage = false;
      this.updateBtn = false;
      this.remainAmt =   this.RAmt - tempData.TotalPaidAmount;
      this.newPaid = parseInt(this.lastPaid) + parseInt(tempData.TotalPaidAmount);
     
    }
    if(tempData.TotalPaidAmount == this.totalAmount){
      const Data= this.FeeForm.controls.feeHeadArray.value;
      this.FeeTable = Data;
      this.FeeTable.forEach((element,i) => {  
        this.feeApplyArray = this.FeeForm.get('feeHeadArray') as FormArray;
        this.feeApplyArray.at(i).get('FeePaid').setValue(element.FeeAmt);
        });
    }
  }
 
 
  fetchPayMode() {
    const payload = {};
    payload['CdType'] = 'PM';
    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.payModeList = res.data;
        this.filteredpayModeList = this.payModeList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }
}